import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el producto?',
  a: 'Recibirás acceso inmediato en formato digital apenas completes tu compra.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El sistema está diseñado tanto para principiantes como para personas con experiencia.'
}, {
  q: '¿Necesito equipamiento?',
  a: 'No. Puedes empezar desde casa sin máquinas ni equipamiento caro.'
}, {
  q: '¿Cuánto tiempo necesito por día?',
  a: 'Las rutinas son flexibles y se adaptan a horarios reales.'
}, {
  q: '¿Los bonus vienen incluidos?',
  a: 'Sí. Los 3 bonus están incluidos sin costo extra.'
}, {
  q: '¿Qué diferencia tiene con videos de YouTube?',
  a: 'Aquí tienes un sistema estructurado y organizado paso a paso para evitar perder tiempo improvisando.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="text-center mb-16" data-id="element-85">
          <h2 className="text-5xl md:text-6xl font-display uppercase text-white" data-id="element-86">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-87">
          {faqs.map((faq, i) => <div key={i} className="bg-dark-card border border-dark-border rounded-xl overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left" data-id="element-89">
                <span className="text-lg font-bold text-white" data-id="element-90">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-91" />
              </button>

              <AnimatePresence data-id="element-92">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-93">
                    <div className="p-6 pt-0 text-gray-400" data-id="element-94">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}